// Pages cross-fade from one to the next (the view-transition meta in the layout). Two adjustments
// keep that smooth:
//
// - A new page starts at the top. Turbo scrolls there only after it has put the new page in, and some
//   browsers picture the page for the transition before that, so it would slide in halfway down. Going
//   Back still returns to where you were (Turbo restores those visits itself).
// - Event links count the click and then redirect to the event, after which Turbo renders the page it
//   has just shown a second time. That render isn't animated, so the page doesn't fade in twice.

let action = null
let redirected = false
let skipNextTransition = false

addEventListener("turbo:before-fetch-response", (event) => {
  if (event.detail.fetchResponse?.redirected) redirected = true
})

addEventListener("turbo:visit", (event) => {
  action = event.detail.action
  if (redirected && action === "replace") skipNextTransition = true
})

addEventListener("turbo:before-render", () => {
  if (action && action !== "restore") window.scrollTo(0, 0)
})

addEventListener("turbo:load", () => {
  action = null
  redirected = false
  skipNextTransition = false
})

const startViewTransition = document.startViewTransition?.bind(document)
if (startViewTransition) {
  document.startViewTransition = (update) => {
    const transition = startViewTransition(update)
    if (skipNextTransition) {
      skipNextTransition = false
      transition.skipTransition()
    }
    return transition
  }
}
